import type { SxProps, Theme } from "@mui/material/styles";
import { COLORS } from "components/v3/Theme/colors";

/** Stable class on {@link FormTemplateWrapper} root for scoped overrides (JSS names are hashed). */
export const AGREEMENT_FORM_TEMPLATE_ROOT_CLASS = "agreement-form-template-survey";

type ResponsiveSpacing = {
  md?: number;
  sm?: number;
  xs?: number;
};

export type AgreementFormSurveyScopeOptions = {
  scrollContentMaxHeight: string;
  paddingLeft?: ResponsiveSpacing;
};

export function getAgreementFormSurveyScopeSx({
  scrollContentMaxHeight,
  paddingLeft
}: AgreementFormSurveyScopeOptions): SxProps<Theme> {
  return {
    backgroundColor: COLORS.WHITE,
    borderRadius: "12px",
    boxSizing: "border-box",
    display: "flex",
    flex: "1 1 0%",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
    p: { md: 2, xs: 1.5 },
    ...(paddingLeft ? { pl: paddingLeft } : {}),
    [`& .${AGREEMENT_FORM_TEMPLATE_ROOT_CLASS}`]: {
      marginBottom: "0 !important",
      minHeight: "0 !important"
    },
    [`& .${AGREEMENT_FORM_TEMPLATE_ROOT_CLASS} .sd-container-modern`]: {
      minHeight: "0 !important"
    },
    [`& .${AGREEMENT_FORM_TEMPLATE_ROOT_CLASS} .terms-scrollable-panel`]: {
      backgroundColor: "transparent",
      border: "none",
      borderRadius: 0,
      display: "flex",
      flex: "1 1 0%",
      flexDirection: "column",
      height: "auto !important",
      maxHeight: "none !important",
      minHeight: "0 !important",
      minWidth: 0,
      overflow: "hidden"
    },
    [`& .${AGREEMENT_FORM_TEMPLATE_ROOT_CLASS} .terms-scrollable-panel__content`]:
      {
        flex: "1 1 0% !important",
        height: "0 !important",
        maxHeight: scrollContentMaxHeight,
        minHeight: "0 !important",
        minWidth: 0,
        overflowX: "hidden",
        overflowY: "auto !important"
      },
    "& .sd-row:has(.terms-scrollable-panel) > .sd-element, & .sd-row:has(.terms-scrollable-panel) .sd-element__content, & .sd-element:has(.terms-scrollable-panel), & .sd-element--with-frame:has(.terms-scrollable-panel), & .sd-element__content:has(.terms-scrollable-panel)":
      {
        display: "flex",
        flex: "1 1 0%",
        flexDirection: "column",
        minHeight: "0 !important",
        minWidth: 0,
        overflow: "hidden"
      },
    "& .sd-root-modern": {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      height: "100%",
      minHeight: 0,
      overflow: "hidden"
    },
    "& .sv-scroll__wrapper, & .sv-scroll__container": {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      minHeight: 0,
      overflow: "hidden"
    },
    "& .sd-root-modern__wrapper": {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      marginTop: 0,
      minHeight: 0,
      overflow: "hidden"
    },
    "& .sd-container-modern": {
      display: "flex !important",
      flex: 1,
      flexDirection: "column !important",
      height: "100% !important",
      maxHeight: "100% !important",
      minHeight: "0 !important",
      overflow: "hidden !important"
    },
    "& .sd-body": {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      minHeight: 0,
      overflow: "hidden"
    },
    "& .sd-page": {
      display: "flex",
      flex: 1,
      flexDirection: "column",
      height: "100%",
      minHeight: 0,
      overflow: "hidden"
    },
    "& .sd-row:has(.terms-scrollable-panel)": {
      display: "flex",
      flex: "1 1 0%",
      flexDirection: "column",
      minHeight: 0,
      minWidth: 0,
      overflow: "hidden"
    },
    "& .sd-row:has(.terms-checkbox-with-button)": {
      flexShrink: 0
    },
    "& .terms-checkbox-with-button": {
      flexGrow: 0,
      flexShrink: "0 !important",
      maxWidth: "100%",
      minWidth: 0,
      pt: 2,
      width: "100%",
      "& .MuiBox-root": {
        my: "0 !important"
      }
    },
    "& .sd-element:has(.terms-checkbox-with-button), & .sd-element--with-frame:has(.terms-checkbox-with-button)":
      {
        flexGrow: 0,
        flexShrink: "0 !important",
        minHeight: "min-content"
      }
  };
}
